import FadeInComponent from "../ui/FadeInComponent";
import styles from "./Delivery.module.css";
import { Parallax } from 'react-scroll-parallax';

interface LogoElement {
    href: string;
    backgroundColor: string;
    imgSrc: string;
    imgAlt: string;
}

const logoWrapperClassName = `col-8 col-lg-3 p-4 rounded-4 d-flex align-items-center justify-content-center overflow-hidden`;
const deliveryLogoList : LogoElement[] = [
    {
        href: "https://www.doordash.com/store/alo-asian-kitchen-laguna-niguel-2860831/14533557/",
        backgroundColor: "#F3D1CD",
        imgSrc: "./images/doordash-logo.png",
        imgAlt: "doordash logo"
    },
    {
        href: "https://www.ubereats.com/store/alo-asian-kitchen/ImfQSv5STdGfdW-plxZmeQ?diningMode=DELIVERY&pl=JTdCJTIyYWRkcmVzcyUyMiUzQSUyMjkxODglMjBHbGVub2FrcyUyMEJsdmQlMjIlMkMlMjJyZWZlcmVuY2UlMjIlM0ElMjIwZDk5ZTA1OC00Y2M5LTM0YjktZmQwYy03OWY0YzUxNTAyODAlMjIlMkMlMjJyZWZlcmVuY2VUeXBlJTIyJTNBJTIydWJlcl9wbGFjZXMlMjIlMkMlMjJsYXRpdHVkZSUyMiUzQTM0LjIzNjI5NSUyQyUyMmxvbmdpdHVkZSUyMiUzQS0xMTguMzcxNjUzJTdE",
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        imgSrc: "./images/order-with-uber-eats-logo.png",
        imgAlt: "order with uber eats logo, green background"
    },
    {
        href: "https://www.grubhub.com/restaurant/alo-asian-kitchen-28083-moulton-pkwy-laguna-niguel/10537096",
        backgroundColor: "#F7AC00",
        imgSrc: "./images/grubhub-logo-white.png",
        imgAlt: "grubhub logo white"
    }
]

function Delivery() {

    return (
        <section
        id="delivery" 
        className="parallax-wrapper container-fluid pt-4 pb-5">

            
            <Parallax 
            speed={-25}
            easing={"easeInOut"}
            className="parallax-background" 
            style={{ 
                backgroundImage: `url('/images/background/delivery-7.webp')`
            }}/>

            <div className="overlay" />

            <FadeInComponent
            className="text-center my-heading">
                <h2>Delivery</h2>
                <p>Can't come for the food? Let the food come to you!</p>
            </FadeInComponent>

            <FadeInComponent 
            className={`row justify-content-center px-5 mt-5 mb-3 gap-5 ${styles["responsive-row"]}`}>
                {deliveryLogoList.map(dl => (
                    <a
                    key={dl.href}
                    href={dl.href}
                    target="_blank" rel="noopener noreferrer"
                    className={`${logoWrapperClassName}`}
                    style={{ backgroundColor: dl.backgroundColor}}>
                        <img
                        className="d-block img-fluid"
                        src={dl.imgSrc}
                        alt={dl.imgAlt}
                        style={{ objectFit: 'contain' }} />
                    </a>
                ))}
            </FadeInComponent>
        </section>
    );
}

export default Delivery;